import { Taf } from '@huyafed/taf-network';

var HUYA = HUYA || {};
global.HUYA = HUYA;

HUYA.GetUserProfileReq = function () {
  this.tId = new HUYA.UserId();
  this.lUid = 0;
};

HUYA.GetUserProfileReq.prototype.readFrom = function (is) {
  this.tId = is.readStruct(0, false, this.tId);
  this.lUid = is.readInt64(1, false, this.lUid);
};

HUYA.GetUserProfileReq.prototype.writeTo = function (os) {
  this.tId = os.writeStruct(0, this.tId);
  this.lUid = os.writeInt64(1, this.lUid);
};

HUYA.GetUserProfileReq.prototype._clone = function () {
  return new HUYA.GetUserProfileReq();
};
HUYA.GetUserProfileReq.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.GetUserProfileReq.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

HUYA.UserId = function () {
  this.lUid = 0;
  this.sGuid = "";
  this.sToken = "";
  this.sHuYaUA = "";
  this.sCookie = "";
  this.iTokenType = 0;
  this.sDeviceInfo = "";
};

HUYA.UserId.prototype.readFrom = function (is) {
  this.lUid = is.readInt64(0, false, this.lUid);
  this.sGuid = is.readString(1, false, this.sGuid);
  this.sToken = is.readString(2, false, this.sToken);
  this.sHuYaUA = is.readString(3, false, this.sHuYaUA);
  this.sCookie = is.readString(4, false, this.sCookie);
  this.iTokenType = is.readInt32(5, false, this.iTokenType);
  this.sDeviceInfo = is.readString(6, false, this.sDeviceInfo);
};

HUYA.UserId.prototype.writeTo = function (os) {
  this.lUid = os.writeInt64(0, this.lUid);
  this.sGuid = os.writeString(1, this.sGuid);
  this.sToken = os.writeString(2, this.sToken);
  this.sHuYaUA = os.writeString(3, this.sHuYaUA);
  this.sCookie = os.writeString(4, this.sCookie);
  this.iTokenType = os.writeInt32(5, this.iTokenType);
  this.sDeviceInfo = os.writeString(6, this.sDeviceInfo);
};

HUYA.UserId.prototype._clone = function () {
  return new HUYA.UserId();
};
HUYA.UserId.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.UserId.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

HUYA.GetUserProfileRsp = function () {
  this.tUserProfile = new HUYA.UserProfile();
};

HUYA.GetUserProfileRsp.prototype.readFrom = function (is) {
  this.tUserProfile = is.readStruct(0, false, this.tUserProfile);
};

HUYA.GetUserProfileRsp.prototype.writeTo = function (os) {
  this.tUserProfile = os.writeStruct(0, this.tUserProfile);
};

HUYA.GetUserProfileRsp.prototype._clone = function () {
  return new HUYA.GetUserProfileRsp();
};
HUYA.GetUserProfileRsp.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.GetUserProfileRsp.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

HUYA.UserProfile = function () {
  this.tUserBase = new HUYA.UserBase();
  this.tPresenterBase = new HUYA.PresenterBase();
  this.tRecentLive = new HUYA.GameLiveInfo();
};

HUYA.UserProfile.prototype.readFrom = function (is) {
  this.tUserBase = is.readStruct(0, false, this.tUserBase);
  this.tPresenterBase = is.readStruct(1, false, this.tPresenterBase);
  this.tRecentLive = is.readStruct(2, false, this.tRecentLive);
};

HUYA.UserProfile.prototype.writeTo = function (os) {
  this.tUserBase = os.writeStruct(0, this.tUserBase);
  this.tPresenterBase = os.writeStruct(1, this.tPresenterBase);
  this.tRecentLive = os.writeStruct(2, this.tRecentLive);
};

HUYA.UserProfile.prototype._clone = function () {
  return new HUYA.UserProfile();
};
HUYA.UserProfile.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.UserProfile.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

HUYA.UserBase = function () {
  this.lUid = 0;
  this.sNickName = "";
  this.sAvatarUrl = "";
  this.iGender = 0;
  this.lYYId = 0;
  this.iCertified = 0;
  this.iSubscribedCount = 0;
  this.iSubscribeToCount = 0;
  this.iUserLevel = 0;
  this.lUserExp = 0;
  this.iBirthday = 0;
  this.sSign = "";
  this.sArea = "";
  this.sLocation = "";
  this.sRegisterTime = "";
  this.iFreezeTime = 0;
  this.iBindPhone = 0;
  this.sHuyaId = "";
  this.iModifyNickChannel = 0;
  this.iLogoutStatus = 0;
};

HUYA.UserBase.prototype.readFrom = function (is) {
  this.lUid = is.readInt64(0, false, this.lUid);
  this.sNickName = is.readString(1, false, this.sNickName);
  this.sAvatarUrl = is.readString(2, false, this.sAvatarUrl);
  this.iGender = is.readInt32(3, false, this.iGender);
  this.lYYId = is.readInt64(4, false, this.lYYId);
  this.iCertified = is.readInt32(5, false, this.iCertified);
  this.iSubscribedCount = is.readInt32(6, false, this.iSubscribedCount);
  this.iSubscribeToCount = is.readInt32(7, false, this.iSubscribeToCount);
  this.iUserLevel = is.readInt32(8, false, this.iUserLevel);
  this.lUserExp = is.readInt64(9, false, this.lUserExp);
  this.iBirthday = is.readInt32(10, false, this.iBirthday);
  this.sSign = is.readString(11, false, this.sSign);
  this.sArea = is.readString(12, false, this.sArea);
  this.sLocation = is.readString(13, false, this.sLocation);
  this.sRegisterTime = is.readString(14, false, this.sRegisterTime);
  this.iFreezeTime = is.readInt32(15, false, this.iFreezeTime);
  this.iBindPhone = is.readInt32(16, false, this.iBindPhone);
  this.sHuyaId = is.readString(17, false, this.sHuyaId);
  this.iModifyNickChannel = is.readInt32(18, false, this.iModifyNickChannel);
  this.iLogoutStatus = is.readInt32(20, false, this.iLogoutStatus);
};

HUYA.UserBase.prototype.writeTo = function (os) {
  this.lUid = os.writeInt64(0, this.lUid);
  this.sNickName = os.writeString(1, this.sNickName);
  this.sAvatarUrl = os.writeString(2, this.sAvatarUrl);
  this.iGender = os.writeInt32(3, this.iGender);
  this.lYYId = os.writeInt64(4, this.lYYId);
  this.iCertified = os.writeInt32(5, this.iCertified);
  this.iSubscribedCount = os.writeInt32(6, this.iSubscribedCount);
  this.iSubscribeToCount = os.writeInt32(7, this.iSubscribeToCount);
  this.iUserLevel = os.writeInt32(8, this.iUserLevel);
  this.lUserExp = os.writeInt64(9, this.lUserExp);
  this.iBirthday = os.writeInt32(10, this.iBirthday);
  this.sSign = os.writeString(11, this.sSign);
  this.sArea = os.writeString(12, this.sArea);
  this.sLocation = os.writeString(13, this.sLocation);
  this.sRegisterTime = os.writeString(14, this.sRegisterTime);
  this.iFreezeTime = os.writeInt32(15, this.iFreezeTime);
  this.iBindPhone = os.writeInt32(16, this.iBindPhone);
  this.sHuyaId = os.writeString(17, this.sHuyaId);
  this.iModifyNickChannel = os.writeInt32(18, this.iModifyNickChannel);
  this.iLogoutStatus = os.writeInt32(20, this.iLogoutStatus);
};

HUYA.UserBase.prototype._clone = function () {
  return new HUYA.UserBase();
};
HUYA.UserBase.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.UserBase.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

HUYA.PresenterBase = function () {
  this.iIsPresenter = 0;
  this.sPresenterName = "";
  this.lSignedChannel = 0;
  this.sPrivateHost = "";
  this.iRecType = 0;
  this.iFreeze = 0;
  this.iPresenterLevel = 0;
  this.lPresenterExp = 0;
  this.vPresentedGames = new Taf.Vector(new HUYA.GameBaseInfo());
  this.iCertified = 0;
  this.iRoomId = 0;
};

HUYA.PresenterBase.prototype.readFrom = function (is) {
  this.iIsPresenter = is.readInt32(0, false, this.iIsPresenter);
  this.sPresenterName = is.readString(1, false, this.sPresenterName);
  this.lSignedChannel = is.readInt64(2, false, this.lSignedChannel);
  this.sPrivateHost = is.readString(3, false, this.sPrivateHost);
  this.iRecType = is.readInt32(4, false, this.iRecType);
  this.iFreeze = is.readInt32(5, false, this.iFreeze);
  this.iPresenterLevel = is.readInt32(6, false, this.iPresenterLevel);
  this.lPresenterExp = is.readInt64(7, false, this.lPresenterExp);
  this.vPresentedGames = is.readVector(8, false, this.vPresentedGames);
  this.iCertified = is.readInt32(9, false, this.iCertified);
  this.iRoomId = is.readInt32(10, false, this.iRoomId);
};

HUYA.PresenterBase.prototype.writeTo = function (os) {
  this.iIsPresenter = os.writeInt32(0, this.iIsPresenter);
  this.sPresenterName = os.writeString(1, this.sPresenterName);
  this.lSignedChannel = os.writeInt64(2, this.lSignedChannel);
  this.sPrivateHost = os.writeString(3, this.sPrivateHost);
  this.iRecType = os.writeInt32(4, this.iRecType);
  this.iFreeze = os.writeInt32(5, this.iFreeze);
  this.iPresenterLevel = os.writeInt32(6, this.iPresenterLevel);
  this.lPresenterExp = os.writeInt64(7, this.lPresenterExp);
  this.vPresentedGames = os.writeVector(8, this.vPresentedGames);
  this.iCertified = os.writeInt32(9, this.iCertified);
  this.iRoomId = os.writeInt32(10, this.iRoomId);
};

HUYA.PresenterBase.prototype._clone = function () {
  return new HUYA.PresenterBase();
};
HUYA.PresenterBase.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.PresenterBase.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

HUYA.GameBaseInfo = function () {
  this.iId = 0;
  this.sFullName = "";
  this.sShortName = "";
  this.sIcon = "";
  this.iCategory = 0;
  this.sCategoryName = "";
  this.iExeId = 0;
};

HUYA.GameBaseInfo.prototype.readFrom = function (is) {
  this.iId = is.readInt32(0, false, this.iId);
  this.sFullName = is.readString(1, false, this.sFullName);
  this.sShortName = is.readString(2, false, this.sShortName);
  this.sIcon = is.readString(3, false, this.sIcon);
  this.iCategory = is.readInt32(4, false, this.iCategory);
  this.sCategoryName = is.readString(5, false, this.sCategoryName);
  this.iExeId = is.readInt32(6, false, this.iExeId);
};

HUYA.GameBaseInfo.prototype.writeTo = function (os) {
  this.iId = os.writeInt32(0, this.iId);
  this.sFullName = os.writeString(1, this.sFullName);
  this.sShortName = os.writeString(2, this.sShortName);
  this.sIcon = os.writeString(3, this.sIcon);
  this.iCategory = os.writeInt32(4, this.iCategory);
  this.sCategoryName = os.writeString(5, this.sCategoryName);
  this.iExeId = os.writeInt32(6, this.iExeId);
};

HUYA.GameBaseInfo.prototype._clone = function () {
  return new HUYA.GameBaseInfo();
};
HUYA.GameBaseInfo.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.GameBaseInfo.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

HUYA.GameLiveInfo = function () {
  this.lLiveId = 0;
  this.lUid = 0;
  this.lChannelId = 0;
  this.iShortChannel = 0;
  this.lSubchannel = 0;
  this.sSubchannelName = "";
  this.iGameId = 0;
  this.sGameName = "";
  this.iAttendeeCount = 0;
  this.eGender = HUYA.EGender.MALE;
  this.iAid = 0;
  this.sNick = "";
  this.sAvatarUrl = "";
  this.iStartTime = 0;
  this.iEndTime = 0;
  this.iSourceType = 0;
  this.bIsCameraOpen = false;
  this.bIsRoomSecret = false;
  this.sVideoCaptureUrl = "";
  this.iCdnAttendee = 0;
  this.lYYId = 0;
  this.bCertified = false;
  this.iRecType = 0;
  this.lSignChannel = 0;
  this.sLiveDesc = "";
  this.iLevel = 0;
  this.sGameShortName = "";
  this.iGameType = 0;
  this.sPrivateHost = "";
  this.iActivityCount = 0;
  this.iStreamType = 0;
  this.iBitRate = 0;
  this.iResolution = 0;
  this.iFrameRate = 0;
  this.iIsMultiStream = 0;
  this.iExeGameId = 0;
  this.lExp = 0;
  this.sReplayHls = "";
  this.lMultiStreamFlag = 0;
  this.iScreenType = 0;
  this.iChannelType = 0;
  this.sLocation = "";
  this.iCodecType = 0;
  this.vPresenterTags = new Taf.Vector(new HUYA.GameLiveTag());
  this.vGameTags = new Taf.Vector(new HUYA.GameLiveTag());
  this.lLiveCompatibleFlag = 0;
  this.sTraceId = "";
  this.iRoomId = 0;
};

HUYA.GameLiveInfo.prototype.readFrom = function (is) {
  this.lLiveId = is.readInt64(0, false, this.lLiveId);
  this.lUid = is.readInt64(1, false, this.lUid);
  this.lChannelId = is.readInt64(2, false, this.lChannelId);
  this.iShortChannel = is.readInt32(3, false, this.iShortChannel);
  this.lSubchannel = is.readInt64(4, false, this.lSubchannel);
  this.sSubchannelName = is.readString(5, false, this.sSubchannelName);
  this.iGameId = is.readInt32(6, false, this.iGameId);
  this.sGameName = is.readString(7, false, this.sGameName);
  this.iAttendeeCount = is.readInt32(8, false, this.iAttendeeCount);
  this.eGender = is.readInt32(9, false, this.eGender);
  this.iAid = is.readInt32(10, false, this.iAid);
  this.sNick = is.readString(11, false, this.sNick);
  this.sAvatarUrl = is.readString(12, false, this.sAvatarUrl);
  this.iStartTime = is.readInt32(13, false, this.iStartTime);
  this.iEndTime = is.readInt32(14, false, this.iEndTime);
  this.iSourceType = is.readInt32(15, false, this.iSourceType);
  this.bIsCameraOpen = is.readBoolean(16, false, this.bIsCameraOpen);
  this.bIsRoomSecret = is.readBoolean(17, false, this.bIsRoomSecret);
  this.sVideoCaptureUrl = is.readString(18, false, this.sVideoCaptureUrl);
  this.iCdnAttendee = is.readInt32(19, false, this.iCdnAttendee);
  this.lYYId = is.readInt64(20, false, this.lYYId);
  this.bCertified = is.readBoolean(21, false, this.bCertified);
  this.iRecType = is.readInt32(22, false, this.iRecType);
  this.lSignChannel = is.readInt64(23, false, this.lSignChannel);
  this.sLiveDesc = is.readString(24, false, this.sLiveDesc);
  this.iLevel = is.readInt32(25, false, this.iLevel);
  this.sGameShortName = is.readString(26, false, this.sGameShortName);
  this.iGameType = is.readInt32(27, false, this.iGameType);
  this.sPrivateHost = is.readString(28, false, this.sPrivateHost);
  this.iActivityCount = is.readInt32(29, false, this.iActivityCount);
  this.iStreamType = is.readInt32(30, false, this.iStreamType);
  this.iBitRate = is.readInt32(31, false, this.iBitRate);
  this.iResolution = is.readInt32(32, false, this.iResolution);
  this.iFrameRate = is.readInt32(33, false, this.iFrameRate);
  this.iIsMultiStream = is.readInt32(34, false, this.iIsMultiStream);
  this.iExeGameId = is.readInt32(35, false, this.iExeGameId);
  this.lExp = is.readInt64(36, false, this.lExp);
  this.sReplayHls = is.readString(37, false, this.sReplayHls);
  this.lMultiStreamFlag = is.readInt64(38, false, this.lMultiStreamFlag);
  this.iScreenType = is.readInt32(39, false, this.iScreenType);
  this.iChannelType = is.readInt32(40, false, this.iChannelType);
  this.sLocation = is.readString(41, false, this.sLocation);
  this.iCodecType = is.readInt32(42, false, this.iCodecType);
  this.vPresenterTags = is.readVector(43, false, this.vPresenterTags);
  this.vGameTags = is.readVector(44, false, this.vGameTags);
  this.lLiveCompatibleFlag = is.readInt64(45, false, this.lLiveCompatibleFlag);
  this.sTraceId = is.readString(46, false, this.sTraceId);
  this.iRoomId = is.readInt32(47, false, this.iRoomId);
};

HUYA.GameLiveInfo.prototype.writeTo = function (os) {
  this.lLiveId = os.writeInt64(0, this.lLiveId);
  this.lUid = os.writeInt64(1, this.lUid);
  this.lChannelId = os.writeInt64(2, this.lChannelId);
  this.iShortChannel = os.writeInt32(3, this.iShortChannel);
  this.lSubchannel = os.writeInt64(4, this.lSubchannel);
  this.sSubchannelName = os.writeString(5, this.sSubchannelName);
  this.iGameId = os.writeInt32(6, this.iGameId);
  this.sGameName = os.writeString(7, this.sGameName);
  this.iAttendeeCount = os.writeInt32(8, this.iAttendeeCount);
  this.eGender = os.writeInt32(9, this.eGender);
  this.iAid = os.writeInt32(10, this.iAid);
  this.sNick = os.writeString(11, this.sNick);
  this.sAvatarUrl = os.writeString(12, this.sAvatarUrl);
  this.iStartTime = os.writeInt32(13, this.iStartTime);
  this.iEndTime = os.writeInt32(14, this.iEndTime);
  this.iSourceType = os.writeInt32(15, this.iSourceType);
  this.bIsCameraOpen = os.writeBoolean(16, this.bIsCameraOpen);
  this.bIsRoomSecret = os.writeBoolean(17, this.bIsRoomSecret);
  this.sVideoCaptureUrl = os.writeString(18, this.sVideoCaptureUrl);
  this.iCdnAttendee = os.writeInt32(19, this.iCdnAttendee);
  this.lYYId = os.writeInt64(20, this.lYYId);
  this.bCertified = os.writeBoolean(21, this.bCertified);
  this.iRecType = os.writeInt32(22, this.iRecType);
  this.lSignChannel = os.writeInt64(23, this.lSignChannel);
  this.sLiveDesc = os.writeString(24, this.sLiveDesc);
  this.iLevel = os.writeInt32(25, this.iLevel);
  this.sGameShortName = os.writeString(26, this.sGameShortName);
  this.iGameType = os.writeInt32(27, this.iGameType);
  this.sPrivateHost = os.writeString(28, this.sPrivateHost);
  this.iActivityCount = os.writeInt32(29, this.iActivityCount);
  this.iStreamType = os.writeInt32(30, this.iStreamType);
  this.iBitRate = os.writeInt32(31, this.iBitRate);
  this.iResolution = os.writeInt32(32, this.iResolution);
  this.iFrameRate = os.writeInt32(33, this.iFrameRate);
  this.iIsMultiStream = os.writeInt32(34, this.iIsMultiStream);
  this.iExeGameId = os.writeInt32(35, this.iExeGameId);
  this.lExp = os.writeInt64(36, this.lExp);
  this.sReplayHls = os.writeString(37, this.sReplayHls);
  this.lMultiStreamFlag = os.writeInt64(38, this.lMultiStreamFlag);
  this.iScreenType = os.writeInt32(39, this.iScreenType);
  this.iChannelType = os.writeInt32(40, this.iChannelType);
  this.sLocation = os.writeString(41, this.sLocation);
  this.iCodecType = os.writeInt32(42, this.iCodecType);
  this.vPresenterTags = os.writeVector(43, this.vPresenterTags);
  this.vGameTags = os.writeVector(44, this.vGameTags);
  this.lLiveCompatibleFlag = os.writeInt64(45, this.lLiveCompatibleFlag);
  this.sTraceId = os.writeString(46, this.sTraceId);
  this.iRoomId = os.writeInt32(47, this.iRoomId);
};

HUYA.GameLiveInfo.prototype._clone = function () {
  return new HUYA.GameLiveInfo();
};
HUYA.GameLiveInfo.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.GameLiveInfo.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};
HUYA.EGender = {
  MALE: 0,
  FEMALE: 1,
};
HUYA.GameLiveTag = function () {
  this.iTagId = 0;
  this.sTagName = "";
  this.bIsShow = true;
  this.iBindingGameId = 0;
  this.iShowType = 0;
};

HUYA.GameLiveTag.prototype.readFrom = function (is) {
  this.iTagId = is.readInt32(0, false, this.iTagId);
  this.sTagName = is.readString(1, false, this.sTagName);
  this.bIsShow = is.readBoolean(2, false, this.bIsShow);
  this.iBindingGameId = is.readInt32(3, false, this.iBindingGameId);
  this.iShowType = is.readInt32(4, false, this.iShowType);
};

HUYA.GameLiveTag.prototype.writeTo = function (os) {
  this.iTagId = os.writeInt32(0, this.iTagId);
  this.sTagName = os.writeString(1, this.sTagName);
  this.bIsShow = os.writeBoolean(2, this.bIsShow);
  this.iBindingGameId = os.writeInt32(3, this.iBindingGameId);
  this.iShowType = os.writeInt32(4, this.iShowType);
};

HUYA.GameLiveTag.prototype._clone = function () {
  return new HUYA.GameLiveTag();
};
HUYA.GameLiveTag.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.GameLiveTag.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

export default HUYA;